export default "__VITE_ASSET__188a8353__"